import { Component, computed, input } from '@angular/core';
import { sonaHlm } from '@sona/angular-util-common';

import type { ClassValue } from 'clsx';

@Component({
    selector: 'hlm-dialog-header',
    standalone: true,
    template: `
        <ng-content />
    `,
    host: {
        '[class]': '_computedClass()'
    }
})
export class HlmDialogHeaderComponent {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected _computedClass = computed(() =>
        sonaHlm('tw-flex tw-flex-col tw-gap-2 tw-text-left', this.userClass())
    );
}
